export class CanvasProtectionError extends Error {
  constructor() {
    super('Browser fingerprint protection is blocking canvas readback. Use SVG instead.')
    this.name = 'CanvasProtectionError'
  }
}

let cached: boolean | null = null

function detect(): boolean {
  let protected_: boolean

  try {
    const canvas = document.createElement('canvas')

    canvas.width = 1
    canvas.height = 1

    const context = canvas.getContext('2d')

    if (!context) {
      protected_ = true
    } else {
      context.fillStyle = 'rgb(47, 113, 211)'
      context.fillRect(0, 0, 1, 1)

      const [r, g, b] = context.getImageData(0, 0, 1, 1).data

      protected_ = r !== 47 || g !== 113 || b !== 211
    }
  } catch {
    protected_ = true
  }

  return protected_
}

export function isCanvasProtected(): boolean {
  if (cached === null) {
    cached = detect()
  }

  return cached
}

export function ensureCanvasReadable(): void {
  if (isCanvasProtected()) {
    throw new CanvasProtectionError()
  }
}
